// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { MintRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Mint';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useMintRequests2Step = <T = TemplateContract<MintRequest>[]>(
  select?: (data: TemplateContract<MintRequest>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();
  return useQueryWithOptions({
    queryFn: async (_, options) => {
      return ledgerApi.query(options, MintRequest);
    },
    select,
  });
};
